<div class="bg-white rounded shadow p-3">
  <div class="flex items-center justify-between mb-4">
    <button
      class="px-2 py-1 rounded text-blue-600 font-medium transition-all duration-100 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
      (click)="navigate(-1)" [disabled]="currentIndex === 0" style="border:none">
      <i class="fas fa-arrow-left text-2xl font-bold"></i>
    </button>

    <div class="flex-1 mx-3 overflow-x-auto">
      <div class="flex items-center">
        <ng-container *ngFor="let step of visibleSteps; let i = index">
          <div class="flex flex-col items-center text-center mr-4">
            <div
              class="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer transition-all duration-200 transform hover:scale-105"
              [ngClass]="{ 
                  'bg-blue-600 text-white ring-2 ring-blue-200 w-16 h-16': isCurrent(step),
                  'bg-green-500 text-white shadow': step.step_status === 'approved' && !isCurrent(step),
                  'bg-gray-300 text-gray-600': !isCurrent(step) && step.step_status !== 'approved',
                  'bg-yellow-500 text-white w-16 h-16': step.step_status === 'approved' && isCurrent(step)
                }" (click)="onActiveIndexChange(step)">
              <span *ngIf="step.step_status === 'approved'" class="text-lg text-white">✔</span>
              <span *ngIf="step.step_status !== 'approved'" class="font-semibold text-gray-600"
                [ngClass]="{'text-white': isCurrent(step)}">
                {{ getStepNumber(step) }}
              </span>
            </div>
            <div class="mt-1 text-xs transition-all duration-100"
              [ngClass]="isCurrent(step) ? 'text-blue-600 font-bold text-xl' : 'text-gray-600'">
              {{ step.name }}
            </div>
          </div>

          <div *ngIf="i < visibleSteps.length - 1" class="h-1 w-[20%] mx-1 transition-all duration-200"
            [ngClass]="isStepCompleted(step) ? 'bg-green-500' : 'bg-gray-300'"></div>
        </ng-container>
      </div>
    </div>

    <div>
      
      <button
      class="px-2 py-1 rounded text-blue-600 font-medium transition-all duration-100 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
      (click)="navigate(1)" [disabled]="currentIndex >= filteredSteps?.length - 1" style="border:none">
      <i class="pi pi-arrow-right text-2xl font-bold"></i>
    </button>
    </div>
  </div>

  <hr class="mt-3 mb-2">

  <div class="mb-1">
    <div class="flex items-center gap-3 mb-6 w-full">
      <button
        class="flex-1 px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all duration-200 border-none outline-none flex items-center justify-center gap-2"
        (click)="routeConfigExpanded = !routeConfigExpanded">
        <i class="pi text-xs" [ngClass]="routeConfigExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        <span class="text-sm italic tracking-wide">
          {{ routeConfigExpanded ? 'Hide Route Configuration' : 'Show Route Configuration' }}
        </span>
      </button>
    
      <button *ngIf="[19,6,18,20,21,12].includes(currentUserRoleId)"
        class="shrink-0 px-4 py-2.5 bg-white border border-amber-200 text-amber-600 font-bold text-[11px] uppercase tracking-widest rounded-xl shadow-sm hover:bg-amber-50 hover:border-amber-300 transition-all flex items-center gap-2"
        (click)="open()">
        <i class="pi pi-forward text-[10px]"></i>
        Skip Steps
      </button>
      <!-- <button *ngIf="[19,6,18,20,21,12].includes(currentUserRoleId)"
        class="shrink-0 px-4 py-2.5 bg-white border border-emerald-200 text-emerald-600 font-bold text-[11px] uppercase tracking-widest rounded-xl shadow-sm hover:bg-emerald-50 hover:border-emerald-300 transition-all flex items-center gap-2"
        (click)="openSkipTestPopup()">
        <i class="pi pi-check-circle text-[10px]"></i>
        Short Close
      </button> -->
      <button *ngIf="showShortCloseButton && !showShortCloseButton1"
        class="shrink-0 px-4 py-2.5 bg-white border border-emerald-200 text-emerald-600 font-bold text-[11px] uppercase tracking-widest rounded-xl shadow-sm hover:bg-emerald-50 hover:border-emerald-300 transition-all flex items-center gap-2"
        (click)="openSkipTestPopup()">
        <i class="fas fa-folder-closed text-[10px]"></i>
        Short Close
      </button>
     
    </div>

    <div 
        class="mt-2 transition-all duration-200 ease-in-out"
        [ngClass]="routeConfigExpanded ? 'max-h-[1200px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'"
      > <div class="bg-slate-50 rounded-xl border border-slate-200 p-3 mb-6">
            <!-- <div class="flex items-center justify-between mb-4 px-1">
            
              <span  class="text-[9px] font-bold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full" (click)="openDialog(); giveTheRouteconfigAccess()">Edit route config</span>
            </div> -->
           
            <div class="flex items-center gap-0 overflow-x-auto pb-2 custom-scrollbar">
              <ng-container *ngFor="let item of workflowData; let i = index; trackBy: trackByUnitId">
          
                <div class="flex items-center group">
                  <div 
                       class="relative w-36 flex-shrink-0  border-2 rounded-xl p-3 shadow-sm 
                              hover:shadow-md transition-all cursor-pointer group select-none z-10"
                       [ngClass]="{
                         'border-emerald-100 bg-emerald-50 hover:border-emerald-400': item.status === 'completed',
                         'border-amber-100 bg-amber-50 hover:border-amber-400': item.status === 'working',
                         'border-blue-100 bg-blue-50 hover:border-blue-400': item.status === 'pending'
                       }">
                    
                    <div class="flex items-center justify-between mb-2">
                      <span class="text-[10px] font-extrabold text-slate-500">
                        <i class="far fa-calendar-alt mr-1 text-slate-400"></i>{{ item.timestamp | date:'dd/MM' }}
                      </span>
                      
                      <span class="px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-tighter shadow-sm"
                            [ngClass]="{
                              'bg-emerald-100 text-emerald-900': item.status === 'completed',
                              'bg-amber-100 text-amber-900 animate-pulse': item.status === 'working',
                              'bg-blue-100 text-blue-900': item.status === 'pending'
                            }">
                        {{ item.status }}
                      </span>
                    </div>
          
                    <div class="flex items-start gap-2 mb-3">
                      <i class="fas fa-circle-dot text-[8px] mt-1.5"
                         [ngClass]="{
                           'text-emerald-500': item.status === 'completed',
                           'text-amber-500': item.status === 'working',
                           'text-blue-500': item.status === 'pending'
                         }"></i>
                      <div class="font-black text-slate-900 text-[12px] leading-tight line-clamp-2">
                        {{ item.name }}
                      </div>
                    </div>
                    <div>
                    <!-- INSERT_YOUR_CODE -->
                    <button *ngIf="item.unit_id == currentUnit" type="button"
                      class="ml-0 mt-1 px-2 py-0.5 bg-indigo-100 hover:bg-indigo-200 text-indigo-700 text-[10px] rounded-full font-bold shadow-sm transition-all flex items-center gap-1"
                      (click)="openDialog(); giveTheRouteconfigAccess(item)"
                      style="line-height: 1.1;"
                      title="Configure route for this step"
                    >
                      <i class="fas fa-cogs text-xs"></i>
                      Edit Route Config
                    </button>
                    </div>
          
                    <div  (click)="item.children?.length > 0 ? handleUnitClick(item) : null" class="flex items-center justify-between pt-2 border-t border-slate-100">
                      <span class="text-[10px] text-slate-700 font-bold">
                        <i class="fas fa-users-viewfinder mr-1 text-indigo-500"></i>
                        {{ item.children?.length || 0 }} <span class="text-slate-400 font-medium">Units</span>
                      </span>
                      <div class="w-5 h-5 rounded-full bg-slate-50 flex items-center justify-center "[ngClass]="item.children?.length > 0 ? 'group-hover:bg-indigo-600 group-hover:text-white transition-colors' : ''" >
                        <i class="fas fa-chevron-right text-[8px]"></i>
                      </div>
                    </div>
                  </div>
          
                  <div *ngIf="i < workflowData.length - 1" class="flex-shrink-0 w-6 flex items-center justify-center">
                    <div class="h-[2px] w-full bg-slate-400"></div>
                  </div>
                </div>
          
              </ng-container>
            </div>
            <div class="flex items-center gap-0 overflow-x-auto pb-2 custom-scrollbar">
            <ng-container *ngFor="let item of timelineDataList; let i = index; trackBy: trackByUnitId">
        
              <div class="flex items-center group">
                <div 
                     class="relative w-36 flex-shrink-0  border-2 rounded-xl p-3 shadow-sm 
                            hover:shadow-md transition-all cursor-pointer group select-none z-10"
                     [ngClass]="{
                       'border-emerald-100 bg-emerald-50 hover:border-emerald-400': !item.is_active,
                       'border-amber-100 bg-amber-50 hover:border-amber-400': item.is_active,
                     }">
                  
                  <div class="flex items-center justify-between mb-2">
                    <span class="text-[10px] font-extrabold text-slate-500">
                      <i class="far fa-calendar-alt mr-1 text-slate-400"></i>{{ item.timestamp | date:'dd/MM' }}
                    </span>
                    
                    <span class="px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-tighter shadow-sm"
                          [ngClass]="{
                            'bg-emerald-100 text-emerald-900': !item.is_active,
                            'bg-amber-100 text-amber-900 animate-pulse': item.is_active,
                          }">
                      {{ item.is_active ? 'Working' : 'Pending' }}
                    </span>
                  </div>
        
                  <div class="flex items-start gap-2 mb-3">
                    <i class="fas fa-circle-dot text-[8px] mt-1.5"
                       [ngClass]="{
                         'text-emerald-500': !item.is_active,
                         'text-amber-500': item.is_active,
                       }"></i>
                    <div class="font-black text-slate-900 text-[12px] leading-tight line-clamp-2">
                      {{ item?.editors[0]?.unit_name || "UNIT name" }}
                    </div>
                  </div>
                  <div>
                  
                  </div>
        
                  <div  (click)="item?.editors?.length > 0 ? handleUnitClick(item) : null" class="flex items-center justify-between pt-2 border-t border-slate-100">
                    <span class="text-[10px] text-slate-700 font-bold">
                      <i class="fas fa-users-viewfinder mr-1 text-indigo-500"></i>
                      {{item.editors[0]?.is_external_user? item?.editors?.length -1 : item?.editors?.length || 0 }} <span class="text-slate-400 font-medium">Units</span>
                    </span>
                    <div class="w-5 h-5 rounded-full bg-slate-50 flex items-center justify-center "[ngClass]="item?.editors.length > 0 ? 'group-hover:bg-indigo-600 group-hover:text-white transition-colors' : ''" >
                      <i class="fas fa-chevron-right text-[8px]"></i>
                    </div>
                  </div>
                </div>
        
                <div *ngIf="i < timelineDataList.length - 1" class="flex-shrink-0 w-6 flex items-center justify-center">
                  <div class="h-[2px] w-full bg-slate-400"></div>
                </div>
              </div>
        
            </ng-container>
            </div>
          </div>
          
          
          
          
      
    </div>
  </div>

  <ng-template #emptyTemplate>
    <div class="flex flex-col items-center justify-center py-8 text-gray-500">
      <i class="pi pi-inbox text-4xl mb-2 opacity-50"></i>
      <p class="text-base font-medium">No users in the route list</p>
    </div>
  </ng-template>


  <!-- Popup Modal Overlay -->
  <div class="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50 transition-opacity"
    *ngIf="displayDialog">
    <!-- Scrollable content wrapper for controlling overflow -->
    <div class="w-full h-full flex items-center justify-center overflow-auto">
      <!-- Popup Content Card -->
      <div
        class="relative max-w-2xl w-full bg-white rounded-xl shadow-2xl p-6 md:p-8 z-50 animate-fadeIn max-h-[90vh] overflow-y-auto">
        <!-- Close Button -->
        <button type="button" (click)="displayDialog = false"
          class="absolute top-3 right-3 p-2 text-slate-500 hover:text-blue-600 rounded-full hover:bg-slate-100 transition"
          aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <!-- Header -->
        <div class="mb-6">
          <h1 class="text-xl md:text-3xl font-bold text-slate-800 flex items-center gap-3">
            <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Approve & Forward
          </h1>
        </div>

        <!-- Warning Banner -->
        <div *ngIf="shareType === 'external'&& !signatureData"
          class="bg-gradient-to-r from-amber-100 to-orange-100 border-l-4 border-amber-500 p-4 rounded-r-lg my-3">
          <div class="flex items-center gap-3">
            <svg class="w-6 h-6 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77-1.333.192 3 1.732 3z">
              </path>
            </svg>
            <p class="text-sm font-medium text-amber-800">External Routing: Digital signature required</p>
          </div>
        </div>
        <div class="mb-8">
          <label class="block text-sm font-semibold text-slate-700 mb-3">Share With:</label>
          <div class="inline-flex rounded-lg border border-slate-300 overflow-hidden shadow-sm">
            <button type="button" [disabled]="!accessObje.edit" (click)="shareType = 'internal'" [class.bg-slate-800]="shareType === 'internal'"
              [class.text-white]="shareType === 'internal'" [class.bg-white]="shareType !== 'internal'"
              [class.text-slate-700]="shareType !== 'internal'"
              class="px-6 py-2.5 font-medium text-sm transition-all duration-200 flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
              Internal
            </button>
            <button type="button" [disabled]="!accessObje.edit" (click)="shareType = 'external'" [class.bg-slate-800]="shareType === 'external'"
              [class.text-white]="shareType === 'external'" [class.bg-white]="shareType !== 'external'"
              [class.text-slate-700]="shareType !== 'external'"
              class="px-6 py-2.5 font-medium text-sm transition-all duration-200 flex items-center gap-2 border-l border-slate-300">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9">
                </path>
              </svg>
              External
            </button>
          </div>
        </div>

        <div *ngIf="!accessObje.edit &&(accessObje.comment || accessObje.view)" class="bg-amber-50 border-l-4 border-amber-400 p-2 mb-2 rounded shadow-sm">
          <div class="flex items-center gap-2 mb-1">
            <div class="w-5 h-5 rounded-full bg-amber-500 flex items-center justify-center">
              <i class="fas fa-exclamation-circle text-white text-[10px]"></i>
            </div>
            <span class="text-[10px] font-bold text-amber-900 uppercase tracking-wider">
              Permission Note
            </span>
          </div>
          <div class="text-[10px] leading-relaxed font-medium text-amber-800">
            Since you have comment authority so you can only forward file Internally
          </div>
        </div>

        <!-- External Section -->
        <div *ngIf="shareType === 'external'" class="space-y-6 mb-8">
          <div class="mb-6">
            <label class="block text-sm font-semibold text-slate-700 mb-3">Permission Type:</label>
            <div class="flex flex-wrap gap-3">
              <label class="flex items-center cursor-pointer">
                <input type="radio" [disabled]="!accessObje.edit" [(ngModel)]="permissionType" [value]="'edit'" name="internal-permission"
                  class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
                <span class="ml-2 text-sm font-medium text-slate-700">Edit/Approve/Recommend</span>
              </label>
              <!-- <label class="flex items-center cursor-pointer">
                <input type="radio" [disabled]="!accessObje.view" [(ngModel)]="permissionType" [value]="'view'" name="internal-permission"
                  class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
                <span class="ml-2 text-sm font-medium text-slate-700">View</span>
              </label> -->
              <label class="flex items-center cursor-pointer">
                <input type="radio" [disabled]="!accessObje.comment" [(ngModel)]="permissionType" [value]="'comment'" name="internal-permission"
                  class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
                <span class="ml-2 text-sm font-medium text-slate-700">Comment</span>
              </label>
            </div>
          </div>


          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">Select Command</label>
            <div class="w-full">
              <p-dropdown [(ngModel)]="selectedCommand" [options]="commandList" optionLabel="name" optionValue="id"
                [placeholder]="'Choose a command'" name="command" styleClass="w-full rounded" appendTo="body">
              </p-dropdown>
            </div>
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">Select Unit</label>
            <p-dropdown *ngIf="permissionType === 'edit'" [(ngModel)]="selectedUnit" [options]="unitList"
              optionLabel="name" filter="true" filterBy="name" [placeholder]="'Choose a unit'" name="unit"
              styleClass="w-full rounded" appendTo="body">
            </p-dropdown>
            <p-multiSelect *ngIf="permissionType !== 'edit'" [(ngModel)]="selectedUnits" [options]="unitList" optionValue="id"
              optionLabel="name" filter="true" filterBy="name" [placeholder]="'Choose a unit'" name="unit"
              styleClass="w-full rounded" appendTo="body">
            </p-multiSelect>
          </div>
        </div>

        <!-- Internal Section -->
        <div *ngIf="shareType === 'internal'" class="mb-8">
          <!-- Permission Type -->
          <div class="mb-6">
            <label class="block text-sm font-semibold text-slate-700 mb-3">Permission Type:</label>
            <div class="flex flex-wrap gap-3">
              <label class="flex items-center cursor-pointer">
                <input type="radio" [disabled]="!accessObje.edit" [(ngModel)]="permissionType" [value]="'edit'" name="internal-permission"
                  class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
                <span class="ml-2 text-sm font-medium text-slate-700">Edit/Approve/Recommend</span>
              </label>
              <!-- <label class="flex items-center cursor-pointer">
                <input type="radio" [disabled]="!accessObje.view" [(ngModel)]="permissionType" [value]="'view'" name="internal-permission"
                  class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
                <span class="ml-2 text-sm font-medium text-slate-700">View</span>
              </label> -->
              <label class="flex items-center cursor-pointer">
                <input type="radio" [disabled]="!accessObje.comment" [(ngModel)]="permissionType" [value]="'comment'" name="internal-permission"
                  class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
                <span class="ml-2 text-sm font-medium text-slate-700">Comment</span>
              </label>
            </div>
          </div>
          <div class="mb-4">
            <label class="flex items-center cursor-pointer">
              <input [disabled]="permissionType !== 'edit'" type="checkbox" [(ngModel)]="isFinalApproval" name="final-approval"
                class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
              <span class="ml-2 text-sm font-medium text-slate-700">Final Approval</span>
            </label>
          </div>
          <!-- User Selection -->
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">
              {{ permissionType === 'edit' ? 'Select User' : 'Select Users' }}
            </label>
            <p-dropdown *ngIf="permissionType === 'edit'" id="userSelect" [options]="userList" optionLabel="first_name" filter="true"
              filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" [(ngModel)]="selectedUser"
              placeholder="Choose a user" appendTo="body" styleClass="w-full rounded">

              <ng-template pTemplate="selectedItem" let-user>
                <div *ngIf="user">
                  <small>
                    #<strong>{{ user.loginname }}</strong> |
                    <strong>{{ user.first_name }} {{ user.last_name }}</strong>
                  </small>
                </div>
                <div *ngIf="!user" class="dropdown-placeholder">
                  Choose a user
                </div>
              </ng-template>
              <!-- Dropdown list items -->
              <ng-template pTemplate="item" let-user>
                <div class="list-group-item list-group-item-action">
                  <small>
                    #<strong>{{ user.loginname }}</strong> |
                    <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation
                      }}</strong>
                  </small>
                </div>
              </ng-template>
            </p-dropdown>

            <!-- Multi selection for View/Comment permissions -->
            <p-multiSelect *ngIf="permissionType !== 'edit'" [options]="userList" optionLabel="first_name" optionValue="id"
              filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" [(ngModel)]="selectedUsers"
              placeholder="Choose users" appendTo="body" styleClass="w-full rounded">

              <ng-template pTemplate="item" let-user>
                <div class="list-group-item list-group-item-action">
                  <small>
                    #<strong>{{ user.loginname }}</strong> |
                    <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation
                      }}</strong>
                  </small>
                </div>
              </ng-template>
            </p-multiSelect>

          </div>
        </div>

        <!-- Comments -->
        <div class="mb-8">
          <label class="block text-sm font-semibold text-slate-700 mb-2">Comment </label>
          <textarea [(ngModel)]="internalComment" rows="4" placeholder="Add your comments here..."
            class="w-full px-4 py-3 border-2 biredr-gray-500 bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-slate-700 resize-none"
            name="internalComment"></textarea>
          <div *ngIf="signatureData" class="flex flex-end mt-3">
            <div
              class="flex flex-wrap items-center justify-between bg-blue-50 p-2 border-2 border-blue-500 rounded-lg w-[350px]">
              <div class="flex items-center">
                <div class="mr-4 w-[70px]">
                  <img *ngIf="signatureData" [src]="signatureData.qr_code" alt="QR Code"
                    class="max-w-full h-auto rounded" />
                </div>
                <div>
                  <div class="text-xs text-gray-500 mb-1">
                    <span class="font-semibold">Electronically Signed by:</span><br>
                    {{ signatureData?.rankName || 'N/A' }}
                    {{ signatureData?.first_name }} {{ signatureData?.last_name }}
                  </div>
                  <div class="text-xs mb-0">
                    <span class="text-gray-700 font-semibold">Designation:</span>
                    {{ signatureData?.hrcdf_designation || 'N/A' }}
                  </div>
                  <div class="text-xs">
                    <span class="text-gray-700 font-semibold">Directorate:</span>
                    {{ signatureData?.unit?.name || 'N/A' }}
                  </div>
                </div>
              </div>

            </div>
          </div>
          <button *ngIf="!signatureData" type="button" (click)="addSignature()"
            class="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-all float-right mb-4">
            Add Signature
          </button>
        </div>



        <!-- Action Buttons -->
        <div class="flex flex-wrap gap-3 justify-end">
          <button type="button" (click)="displayDialog = false"
            class="px-4 py-1 bg-white border-2 border-slate-300 text-slate-700 rounded font-medium hover:bg-slate-50 transition-all duration-200 shadow-sm">
            Cancel
          </button>
          <button (click)="submitShare()" [disabled]="isLoading || (shareType === 'external'&& !signatureData)"
            [class.opacity-50]="isLoading" [class.cursor-not-allowed]="isLoading"
            class="px-4 py-1 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded font-medium hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center gap-2 disabled:from-slate-400 disabled:to-slate-500">
            <svg *ngIf="!isLoading" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <svg *ngIf="isLoading" class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ isLoading ? 'Submitting...' : 'Submit' }}
          </button>
        </div>
        <!-- </form> -->
      </div>
    </div>
  </div>
  </div>
  <div *ngIf="showModal && editorData"  class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 transition-all">

  <div
    class="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[92vh] overflow-hidden flex flex-col border border-slate-200">



    <div *ngIf="editorData && editorData.editors && editorData.editors.length > 0">
      <div *ngIf="!editorData.editors[0]?.is_external_user" class="px-4 pt-3 pb-2 bg-slate-100 border-b-2">
        <div class="flex justify-between items-start">
          <div class="flex items-end gap-2">
            <h2 class="text-2xl font-extrabold tracking-tight">
              <i class="fas fa-user-circle text-gray-300 mr-2 text-2xl group-hover:text-blue-400 transition-colors"></i>
              {{editorData.editors?.[0]?.unit_name }} File Movement History
            </h2>
            <div class="flex items-center gap-3 mb-1">
              <span
                class="bg-gradient-to-r from-indigo-500 to-purple-500 px-3 py-0.5 rounded-full text-[10px] tracking-wider font-bold text-white shadow-lg shadow-indigo-500/30">
                USER ID: {{ editorData.editors[0]?.loginname || 'N/A' }}
              </span>
              <span [ngClass]="getStatusColor(editorData.is_active)"
                class="px-3 py-0.5 text-white rounded-full text-[10px] uppercase tracking-wider font-bold shadow-lg">
                {{ editorData.is_active ? 'Active' : 'Inactive' }}
              </span>
              <span
                class="bg-gradient-to-r from-emerald-500 to-teal-500 px-3 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-bold text-white shadow-lg shadow-emerald-500/30">
                Forwarded <i class="pi pi-send text-xs ml-1"></i>
              </span>
              
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="editorData.editors[0]?.is_external_user" class="px-4 pt-3 pb-2 bg-slate-100 border-b-2">
        <div class="flex justify-between items-start">
          <div class="flex items-end gap-2">
            <h2 class="text-2xl font-extrabold tracking-tight">
              <i class="fas fa-user-circle text-gray-300 mr-2 text-2xl group-hover:text-blue-400 transition-colors"></i>
              {{editorData.editors?.[0]?.unit_name }} File Movement History
            </h2>
            <div class="flex items-center gap-3 mb-1">
              <span
                class="bg-gradient-to-r from-indigo-500 to-purple-500 px-3 py-0.5 rounded-full text-[10px] tracking-wider font-bold text-white shadow-lg shadow-indigo-500/30">
                USER ID: {{ editorData.editors[0]?.loginname || 'N/A' }}
              </span>
              <span [ngClass]="getStatusColor(editorData.is_active)"
                class="px-3 py-0.5 text-white rounded-full text-[10px] uppercase tracking-wider font-bold shadow-lg">
                External User
              </span>
              <span
                class="bg-gradient-to-r from-emerald-500 to-teal-500 px-3 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-bold text-white shadow-lg shadow-emerald-500/30">
                Forwarded <i class="pi pi-send text-xs ml-1"></i>
              </span>
              <!-- <button type="button" *ngIf="editorData.editors[0]?.user_id == currentUser && editorData.editors[0]?.can_root"
                class="px-3 py-1.5  bg-indigo-100 hover:bg-indigo-200 text-indigo-700 text-[10px] rounded font-bold shadow-sm transition-all flex items-center gap-1"
                (click)="openDialog(); giveTheRouteconfigAccess(editorData.editors[0]); showModal=false;"
                style="line-height: 1.1;" title="Configure route for this step">
                <i class="fas fa-cogs text-[10px]"></i>
                Edit Route Config
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-8 overflow-y-auto space-y-10 custom-scrollbar">
      <div>
        <div class="flex items-center gap-2 mb-4">
          <div class="w-7 h-7 rounded bg-emerald-50 flex items-center justify-center">
            <i class="fas fa-sitemap text-emerald-600 text-xs"></i>
          </div>
          <h3 class="text-sm font-bold text-slate-700 uppercase tracking-tight">User Details</h3>
        </div>
        <div class="space-y-4">
          <ng-container *ngFor="let editor of editorData.editors; let idx = index">
            <div class="w-full bg-white border border-slate-100 rounded-xl p-3 shadow-sm transition-all group"
              *ngIf="!(editorData.editors[0]?.is_external_user && idx === 0)">
              <div class="flex items-center justify-between gap-3">
                <div class="flex items-center gap-3">
                  <div
                    class="w-9 h-9 rounded-lg bg-emerald-600 flex items-center justify-center text-white shadow-sm flex-shrink-0">
                    <i class="fas fa-user-circle text-lg"></i>
                  </div>
                  <div>
                    <h4
                      class="text-sm font-bold text-slate-800 leading-tight group-hover:text-emerald-700 transition-colors">
                      {{ editor.loginname }}
                      <button type="button" *ngIf="editor.user_id == currentUser && (editor.can_root || editor.can_edit)"
                        class="px-1 py-[2px] bg-indigo-100 hover:bg-indigo-200 text-indigo-700 text-[8px] rounded-full font-bold shadow-sm transition-all flex items-center gap-1"
                        (click)="openDialog(); giveTheRouteconfigAccess(!(editorData.editors[1]?.is_external_user && idx === 0)?editorData.editors[0]: editor); showModal=false;"
                        style="line-height: 1.1;" title="Configure route for this step">
                        <i class="fas fa-cogs text-[8px]"></i>
                        Edit Route Config
                      </button>
                    </h4>
                    <div class="flex items-center gap-2 mt-0.5">
                      <span class="text-[10px] text-slate-600 font-medium">{{ editor?.hrcdf_designation }}</span>
                      <span class="text-[10px] text-slate-300">|</span>
                      <span class="text-[10px] text-orange-600 font-bold">
                        <i class="fas fa-lock-open mr-0.5 scale-75"></i>
                        <ng-container *ngIf="editor.can_edit">Edit&nbsp;</ng-container>
                        <ng-container *ngIf="editor.can_comment">Comment&nbsp;</ng-container>
                        <ng-container *ngIf="editor.can_view">View&nbsp;</ng-container>
                        <ng-container *ngIf="editor.is_external_user">Route</ng-container>
                        <ng-container
                          *ngIf="!editor.can_edit && !editor.can_comment && !editor.can_view && !editor.can_root">No
                          Permissions</ng-container>
                      </span>
                    </div>
                  </div>
                </div>
                <span [ngClass]="{ 'bg-emerald-400': editor.is_working, 'bg-amber-400': !editor.is_working }"
                  class="px-2.5 py-0.5 rounded-md text-[9px] font-bold uppercase tracking-wider text-white">
                  {{ editor.is_working ? 'Active' : 'Inactive' }}
                </span>
              </div>
              <div class="mt-3 pl-10 space-y-2">
                <div class="flex items-center gap-2 text-[10px]">
                  <div class="flex items-center gap-1">
                    <i class="fas fa-user-shield" [class.text-slate-400]="!editor.can_edit"
                      [class.text-green-500]="editor.can_edit"></i>
                    <span [ngClass]="{'text-slate-400': !editor.can_edit, 'font-bold text-green-700': editor.can_edit}">
                      Can Edit: {{ editor.can_edit ? 'Yes' : 'No' }}
                    </span>
                  </div>
                  <div class="flex items-center gap-1">
                    <i class="fas fa-comments" [class.text-slate-400]="!editor.can_comment"
                      [class.text-amber-500]="editor.can_comment"></i>
                    <span
                      [ngClass]="{'text-slate-400': !editor.can_comment, 'font-bold text-amber-700': editor.can_comment}">
                      Can Comment: {{ editor.can_comment ? 'Yes' : 'No' }}
                    </span>
                  </div>
                  <div class="flex items-center gap-1">
                    <i class="fas fa-eye" [class.text-slate-400]="!editor.can_view"
                      [class.text-blue-500]="editor.can_view"></i>
                    <span [ngClass]="{'text-slate-400': !editor.can_view, 'font-bold text-blue-700': editor.can_view}">
                      Can View: {{ editor.can_view ? 'Yes' : 'No' }}
                    </span>
                  </div>
                  <div class="flex items-center gap-1">
                    <i class="fas fa-code-branch" [class.text-slate-400]="!editor.can_root"
                      [class.text-fuchsia-500]="editor.can_root"></i>
                    <span
                      [ngClass]="{'text-slate-400': !editor.can_root, 'font-bold text-fuchsia-700': editor.can_root}">
                      Can Route: {{ editor.can_root ? 'Yes' : 'No' }}
                    </span>
                  </div>
                </div>
                <!-- <div class="flex items-center gap-2 text-[10px] mt-2">
                  <span
                    [ngClass]="{'text-red-600 font-bold': editor.is_blocked, 'text-green-700 font-bold': !editor.is_blocked}">
                    <i class="fas" [ngClass]="editor.is_blocked ? 'fa-user-lock' : 'fa-unlock-alt'"></i>
                    {{ editor.is_blocked ? 'Blocked' : 'Not Blocked' }}
                  </span>
                  <span
                    [ngClass]="{'text-emerald-700': editor.is_external_user, 'text-slate-400': !editor.is_external_user}">
                    <i class="fas fa-globe"></i>
                    {{ editor.is_external_user ? 'External User' : 'Internal User' }}
                  </span>
                  <span
                    [ngClass]="{'text-yellow-700 font-bold': editor.is_working, 'text-slate-400': !editor.is_working}">
                    <i class="fas fa-briefcase"></i>
                    {{ editor.is_working ? 'Working' : 'Not Working' }}
                  </span>
                </div> -->
              </div>

              <div *ngIf="getBlockVisible(editor.commentors, 'isInternal')" class="mt-3 pl-10 flex items-center gap-2 mb-3">
                <span class="text-[10px] text-slate-400 font-bold uppercase">Internal Commentors:</span>
                <span class="flex flex-wrap gap-2 mt-1">
                  <ng-container *ngFor="let cmt of editor.commentors">
                    <span *ngIf="!cmt.is_external_user"
                      class="flex items-center gap-1 px-2 py-1 rounded bg-indigo-50/80 border border-indigo-100 text-[10px] font-medium text-indigo-700">
                      <i class="fas fa-user-circle"></i> {{ cmt.loginname }}
                    </span>
                  </ng-container>
                </span>
              </div>

              <div *ngIf="getBlockVisible(editor.commentors, 'isExternal')"
                class="border border-slate-300 rounded-lg overflow-hidden bg-white shadow-md">

                <button
                  (click)="editor.showExternalCommenters = !editor.showExternalCommenters; processGroups(editor.commentors)"
                  class="w-full flex items-center justify-between p-3 px-4 transition-all duration-200 group"
                  [ngClass]="editor.showExternalCommenters ? 'bg-indigo-800 text-white' : 'bg-white text-slate-700 hover:bg-slate-50'">
                  <div class="flex items-center gap-3">
                    <div class="p-1.5 rounded-md"
                      [ngClass]="editor.showExternalCommenters ? 'bg-indigo-600' : 'bg-indigo-50'">
                      <i class="fas fa-user-shield text-[12px]"
                        [ngClass]="editor.showExternalCommenters ? 'text-white' : 'text-indigo-600'"></i>
                    </div>
                    <div class="text-left">
                      <p class="text-[10px] font-black uppercase tracking-[0.15em] leading-none mb-1">External
                        Commenters</p>
                      <p class="text-[8px] font-bold opacity-70 uppercase">{{groupedCommentTurns?.length || ''}}
                        Verified Stakeholders</p>
                    </div>
                  </div>
                  <i class="fas fa-chevron-down text-[10px] transition-transform duration-300"
                    [class.rotate-180]="editor.showExternalCommenters"></i>
                </button>

                <div *ngIf="editor.showExternalCommenters" class="bg-slate-100 p-3 space-y-3">

                  <div *ngFor="let group of groupedCommentTurns"
                    class="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden transition-all duration-200 hover:border-indigo-300 hover:shadow-md">

                    <div (click)="group.expanded = !group.expanded"
                      class="flex items-center justify-between p-3 cursor-pointer select-none bg-white border-b border-slate-50">

                      <div class="flex items-center gap-4">
                        <div
                          class="flex flex-col items-center justify-center px-2 py-1 bg-indigo-50 border border-indigo-100 rounded text-indigo-700">
                          <span class="text-[7px] font-black uppercase leading-none">Turn</span>
                          <span class="text-[12px] font-black leading-none">#{{ group.turn_id }}</span>
                        </div>

                        <div class="flex flex-col">
                          <span class="text-[11px] font-black text-slate-800">{{ group.users[0]?.loginname }}</span>
                          <span class="text-[9px] font-bold text-indigo-500 uppercase tracking-tighter">Unit: {{
                            group.users[0]?.unit_name }}</span>
                        </div>
                      </div>

                      <div class="flex items-center gap-3">
                        <button *ngIf="group.users[0]?.unit_id == currentUnit"
                          (click)="$event.stopPropagation(); openDialog(); giveTheRouteconfigAccess(group.users[0]); showModal=false;"
                          class="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 hover:bg-emerald-600 text-emerald-700 hover:text-white border border-emerald-200 rounded text-[9px] font-black uppercase transition-all shadow-sm active:scale-95">
                          <i class="fas fa-route text-[11px]"></i>
                          <span>Edit Route Config</span>
                        </button>

                        <div class="w-px h-6 bg-slate-100 mx-1"></div>

                        <i class="fas text-[10px] text-slate-300 transition-colors"
                          [ngClass]="group.expanded ? 'fa-minus-circle text-indigo-500' : 'fa-plus-circle'"></i>
                      </div>
                    </div>

                    <div *ngIf="group.expanded" class="p-3 pt-2 bg-slate-50/50 border-t border-slate-50">
                      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                        <ng-container *ngFor="let cmt of group.users ; let idx = index">

                          <div *ngIf="idx !== 0"
                            class="flex items-center justify-between p-2 bg-white border border-slate-200 rounded-md shadow-xs hover:border-indigo-200 transition-colors">

                            <div class="flex items-center gap-3">
                              <div
                                class="w-7 h-7 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-[10px] font-black text-slate-400">
                                {{ (cmt.loginname || 'U').charAt(0).toUpperCase() }}
                              </div>
                              <div class="flex flex-col leading-tight">
                                <span class="text-[10px] font-black text-slate-700">{{ cmt.loginname }}</span>
                                <span class="text-[8px] font-bold text-slate-400 uppercase">Sequence:
                                  {{cmt.sequence}}</span>
                              </div>
                            </div>

                            <div
                              class="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-slate-100 border border-slate-200">
                              <span class="w-1.5 h-1.5 rounded-full"
                                [ngClass]="cmt.is_working ? 'bg-yellow-400' : ' bg-emerald-500'"></span>
                              <span class="text-[7px] font-black text-slate-500 uppercase">{{cmt.is_working ? 'Pending' :
                                'Done'}}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="p-2 bg-slate-50 border-t border-slate-100 flex justify-end">
      <button (click)="closeModal()"
        class="px-6 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 font-bold rounded-xl transition-all">
        Close View
      </button>
    </div>
  </div>


</div>

<p-toast></p-toast>




<div *ngIf="openPop" 
     class="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-sm flex p-4 animate-in fade-in duration-300" 
     (click)="openPop=false">
  
  <div class="m-auto w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-200" 
       (click)="$event.stopPropagation()">
    
    <div class="px-6 py-4 border-b bg-slate-50/50 flex justify-between items-center">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center">
          <i class="pi pi-forward text-amber-600 text-sm"></i>
        </div>
        <h3 class="text-lg font-bold text-slate-800 tracking-tight">Skip Workflow Steps</h3>
      </div>
      <button class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-400 transition-colors" 
              (click)="openPop=false">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="p-6 max-h-[65vh] overflow-y-auto custom-scrollbar space-y-3 bg-slate-50/30">
      <div *ngFor="let s of steps ; let i=index" 
           class="group transition-all duration-200 border rounded-xl p-4 bg-white"
           [ngClass]="s.skipped ? 'border-amber-300 ring-1 ring-amber-100 bg-amber-50/30' : 'border-slate-200 hover:border-blue-300 hover:shadow-sm'">
        
        <div class="flex items-start gap-4">
          <div class="relative flex items-center mt-1">
            <input
                  type="checkbox"
                  [disabled]="isSkipDisabled(s, i)"
                  class="w-5 h-5 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer transition-all"
                  [(ngModel)]="s.skipped"
                  (ngModelChange)="!s.skipped && (s.remark='')" />
          </div>

          <div class="flex-1">
            <div class="flex justify-between items-center mb-1">
              <span class="text-sm font-bold" [ngClass]="s.skipped ? 'text-amber-800' : 'text-slate-700'">
                Step {{s.sequence}}: {{s.name}}
              </span>
              <span class="text-[10px] font-mono font-medium px-2 py-0.5 bg-slate-100 text-slate-500 rounded uppercase tracking-wider">
                {{s.code}}
              </span>
            </div>

            <div *ngIf="s.skipped" class="mt-3 space-y-2 animate-in slide-in-from-top-2 duration-200">
              <textarea 
                class="w-full p-3 text-sm border border-amber-200 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-amber-400 outline-none placeholder:text-slate-400 shadow-sm"
                rows="2" 
                [(ngModel)]="s.remark" 
                placeholder="Please provide a reason for skipping..."></textarea>

              <div *ngIf="!s.remark?.trim()" class="flex items-center gap-1.5 text-xs text-red-500 font-medium">
                <i class="pi pi-exclamation-circle text-[10px]"></i>
                Remark is required to proceed
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="px-6 py-4 border-t bg-white flex justify-end items-center gap-3">
      <button class="px-5 py-2 text-sm font-semibold text-slate-600 hover:text-slate-800 transition-colors" 
              (click)="openPop=false">
        Cancel
      </button>
      <button class="px-6 py-2.5 rounded-xl bg-blue-600 text-white font-bold text-sm shadow-lg shadow-blue-200 transition-all hover:bg-blue-700 active:scale-95 disabled:opacity-40 disabled:pointer-events-none disabled:shadow-none flex items-center gap-2"
        [disabled]="!valid()" 
        (click)="save()">
        <i class="pi pi-check text-xs"></i>
        Save Changes
      </button>
    </div>
  </div>
</div>



<!-- New code skip proposal  -->


<div *ngIf="openSkipTestPop" 
     class="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-sm flex p-4 animate-in fade-in duration-300" 
     (click)="openSkipTestPop=false">
  
  <div class="m-auto w-full max-w-4xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-200" 
       (click)="$event.stopPropagation()">
    
    <!-- Header -->
    <div class="px-6 py-4 border-b bg-slate-50/50 flex justify-between items-center">
      <div class="flex items-center gap-3">
       
        <h3 class="text-lg font-bold text-slate-800 tracking-tight"> Short Close Proposal</h3>
      </div>
      <button class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-400 transition-colors" 
              (click)="openSkipTestPop=false">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Content -->
  <div class="p-6 max-h-[65vh] overflow-y-auto custom-scrollbar space-y-6 bg-slate-50/30">
  
     <!-- Info Alert -->
  <div class="bg-blue-50 border-l-4 border-blue-400 p-3 rounded-r-lg">
    <div class="flex items-start gap-3">
      <i class="pi pi-info-circle text-blue-600 text-sm mt-0.5"></i>
      <p class="text-sm text-blue-800 font-medium">
         Once submitted, this proposal will be moved from <span class="font-bold">Ongoing</span> to <span class="font-bold">Short Close</span> table.
      </p>
    </div>
  </div>
 

  <!-- Editor Remarks -->
  <div class="bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
    <label class="block text-sm font-bold text-slate-700 mb-3 flex items-center gap-2">
      <i class="pi pi-pencil text-amber-600"></i>
      Remarks / Notes <span class="text-red-500">*</span>
    </label>
    <textarea 
      class="w-full p-3 text-sm border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none placeholder:text-slate-400 shadow-sm resize-none"
      rows="4" 
      [(ngModel)]="skipTestRemarks" 
      placeholder="Enter any remarks or notes regarding the short close...">
    </textarea>
    <div class="mt-2 text-xs text-slate-500 flex items-center gap-1">
      <i class="pi pi-info-circle text-[10px]"></i>
      Please provide details about the short close
    </div>
  </div>

   <!-- Upload Document Component -->
  <div class="bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
    <h4 class="text-sm font-bold text-slate-700 mb-4 flex items-center gap-2">
      <i class="pi pi-upload text-blue-600"></i>
      Upload Document
    </h4>
    
    <!-- Custom File Upload -->
    <div class="space-y-3">
      <!-- File Input -->
      <div class="relative border-2 border-dashed border-slate-300 rounded-lg p-6 hover:border-blue-400 transition-all cursor-pointer"
           [ngClass]="{'border-blue-500 bg-blue-50': selectedFile}">
        <input 
          type="file" 
          #fileInput
          (change)="onFileSelected($event)" 
          class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpg,.jpeg"
        />
        
        <div class="text-center">
          <i class="pi pi-cloud-upload text-4xl text-slate-400 mb-2" [ngClass]="{'text-blue-500': selectedFile}"></i>
          
          <div *ngIf="!selectedFile">
            <p class="text-sm font-semibold text-slate-700">Click to upload or drag and drop</p>
            <p class="text-xs text-slate-500 mt-1">PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, PNG, JPG (Max 10MB)</p>
          </div>
          
          <div *ngIf="selectedFile" class="space-y-2">
            <p class="text-sm font-bold text-blue-700">Selected File:</p>
            <div class="flex items-center justify-center gap-2">
              <i class="pi pi-file text-blue-600"></i>
              <span class="text-sm font-medium text-slate-700">{{ selectedFile.name }}</span>
              <span class="text-xs text-slate-500">({{ formatFileSize(selectedFile.size) }})</span>
            </div>
            <button 
              type="button"
              (click)="removeFile($event)"
              class="text-xs text-red-600 hover:text-red-700 font-medium underline">
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

 

</div>

<!-- Footer -->
<div class="px-6 py-4 border-t bg-white flex justify-end items-center gap-3">
  <button class="px-5 py-2 text-sm font-semibold text-slate-600 hover:text-slate-800 transition-colors" 
          (click)="openSkipTestPop=false">
    Cancel
  </button>
  <button class="px-6 py-2.5 rounded-xl bg-emerald-600 text-white font-bold text-sm shadow-lg shadow-emerald-200 transition-all hover:bg-emerald-700 active:scale-95 disabled:opacity-40 disabled:pointer-events-none disabled:shadow-none flex items-center gap-2"
    [disabled]="isSkipTestLoading || !skipTestRemarks?.trim() || !selectedFile" 
    (click)="submitSkipTest()">
    <i *ngIf="!isSkipTestLoading" class="pi pi-check text-xs"></i>
    <svg *ngIf="isSkipTestLoading" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
      </path>
    </svg>
    {{ isSkipTestLoading ? 'Submitting...' : 'Submit' }}
  </button>
</div>
  </div>
</div>


